
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/galerie",
      function () {
        return require("private-next-pages/galerie/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/galerie"])
      });
    }
  